<template>
  <CategoryForm action="edit" :category="category"/>
</template>

<script>
import CategoryForm from '@/components/Category/CategoryForm'
import * as types from '@/store/types.js'
import Category from '@/model/Category'

export default {
  components: {
    CategoryForm
  },
  computed: {
    category () {
      this.$store.dispatch(types.ACTIVE_CATEGORY)
      return this.$store.getters[types.ACTIVE_CATEGORY]
    }
  },
  mounted () {
    this.$store.dispatch(types.ACTIVE_CATEGORY)
    Category.show(this.$route.params.id, {all_languages: true}).then((response) => {
      this.$store.dispatch(types.UPDATE_CATEGORY, response.data.data)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/category/Edit.vue